var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "addEditForm" }, [
    _c("div", { staticClass: "formTitle" }, [_vm._v("个人基本信息修改")]),
    _vm._v(" "),
    _c("div", { staticClass: "ownBox" }, [
      _c(
        "div",
        { staticClass: "footerBtn" },
        [
          _c(
            "div",
            { staticClass: "changerBox" },
            [
              _c("div", { staticClass: "userHdContent" }, [
                _c("img", { attrs: { src: _vm.userImg, alt: "" } }),
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = true
                    },
                  },
                },
                [_vm._v("修改头像")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-dialog",
            {
              staticClass: "pubDia",
              attrs: {
                title: "头像编辑",
                visible: _vm.dialogVisible,
                "before-close": _vm.handleClose,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogVisible = $event
                },
              },
            },
            [
              _c(
                "span",
                [
                  _c("el-row", [
                    _c("input", {
                      ref: "filElem",
                      staticClass: "el-button hide",
                      staticStyle: { "margin-bottom": "15px" },
                      attrs: {
                        type: "file",
                        id: "uploads",
                        accept: "image/png, image/jpeg, image/gif, image/jpg",
                      },
                      on: {
                        change: function ($event) {
                          return _vm.uploadImg($event, 1)
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "upload-img",
                        on: { click: _vm.clickUpload },
                      },
                      [_vm._v("点击上传头像")]
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 14 } },
                        [
                          _c("vueCropper", {
                            ref: "cropper",
                            staticStyle: { width: "100%", height: "300px" },
                            attrs: {
                              img: _vm.attach.customaryUrl,
                              autoCrop: _vm.options.autoCrop,
                              fixedBox: _vm.options.fixedBox,
                              canMoveBox: _vm.options.canMoveBox,
                              autoCropWidth: _vm.options.autoCropWidth,
                              autoCropHeight: _vm.options.autoCropHeight,
                              centerBox: _vm.options.centerBox,
                            },
                            on: { realTime: _vm.realTime },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("el-col", { attrs: { span: 6.5 } }, [
                        _c(
                          "h2",
                          {
                            staticClass: "mar-left-50",
                            attrs: { align: "center" },
                          },
                          [_vm._v("头像预览")]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "show-preview" }, [
                          _c(
                            "div",
                            { staticClass: "preview", style: _vm.previews.div },
                            [
                              _c("img", {
                                style: _vm.previews.img,
                                attrs: { src: _vm.previews.url, width: "100%" },
                              }),
                            ]
                          ),
                        ]),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { staticClass: "footerBtn", attrs: { align: "center" } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary ",
                            size: "medium",
                            round: "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.confirm("blob")
                            },
                          },
                        },
                        [_vm._v("确认")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "info", size: "medium", round: "" },
                          on: { click: _vm.handleClose },
                        },
                        [_vm._v("取消")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "userInfoUpData" },
        [
          _c(
            "el-form",
            {
              ref: "changeForm",
              attrs: {
                "label-width": "220px",
                rules: _vm.rules,
                model: _vm.userInfo,
              },
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "邮箱：", prop: "email" } },
                    [
                      _c("el-input", {
                        attrs: { clearable: "", type: "email" },
                        model: {
                          value: _vm.userInfo.email,
                          callback: function ($$v) {
                            _vm.$set(_vm.userInfo, "email", $$v)
                          },
                          expression: "userInfo.email",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "原始密码：", prop: "oldPassWord" } },
                    [
                      _c("el-input", {
                        attrs: { clearable: "", type: "password" },
                        model: {
                          value: _vm.userInfo.oldPassWord,
                          callback: function ($$v) {
                            _vm.$set(_vm.userInfo, "oldPassWord", $$v)
                          },
                          expression: "userInfo.oldPassWord",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "新密码：", prop: "password" } },
                    [
                      _c("el-input", {
                        attrs: { clearable: "", type: "password" },
                        model: {
                          value: _vm.userInfo.password,
                          callback: function ($$v) {
                            _vm.$set(_vm.userInfo, "password", $$v)
                          },
                          expression: "userInfo.password",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "确认密码：", prop: "isPwd" } },
                    [
                      _c("el-input", {
                        attrs: { clearable: "", type: "password" },
                        model: {
                          value: _vm.userInfo.isPwd,
                          callback: function ($$v) {
                            _vm.$set(_vm.userInfo, "isPwd", $$v)
                          },
                          expression: "userInfo.isPwd",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "submitBtn" },
      [
        _c(
          "el-button",
          {
            attrs: { type: "primary", size: "small" },
            on: {
              click: function ($event) {
                return _vm.submitForm("changeForm")
              },
            },
          },
          [_vm._v("提交")]
        ),
        _vm._v(" "),
        _c(
          "el-button",
          {
            attrs: { type: "primary", size: "small", plain: "" },
            on: {
              click: function ($event) {
                return _vm.resetForm("changeForm")
              },
            },
          },
          [_vm._v("重置")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }